import SuperRepository from '../superRepository'

export default new (class PartnerRiskLevelRepository extends SuperRepository {
  baseUri() {
    return 'auth_log'
  }
  getRiskLevel = ({id, ...params}) => this.httpClient().get(this.baseUri() + `/${id}/matches`, params)
})()
